import { ButtonHTMLAttributes } from 'react'

import { StyledCommonLinkButton } from './styles'

export interface CommonLinkButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {}

export default StyledCommonLinkButton
